module.exports = __webpack_public_path__ + "static/media/status-S.c704f977.svg";